const localConfig = {
    "PRODUCTION": false,
    "BASE_URL": "http://localhost:8080/vadcapi",
    "TEST_ENV": "xyz",
    "METTL_URL": "mettl.xyz",
    "CANDIDATE_URL" : "http://localhost:3000",
    "SOURCE": "local",
    "ADMIN_API_URL": "/admin",
    "CANDIDATE_API_URL": "/vadccandidateapi",
    "AUTHENTICATORS": [{
        "value": "google_authenticator",
        "link": "https://support.google.com/accounts/answer/1066447",
        "enabled": true,
    }, {
        "value": "microsoft_authenticator",
        "link": "https://www.microsoft.com/en/security/mobile-authenticator-app",
        "enabled": true,
    }],
    "candFooterNumbers": [
    {
        "flagClass": "us",
        "label": "+1 (800) 265-6038",
        "link": "tel:+1-800-265-6038"
    },
    {
        "flagClass": "in",
        "label": "+91 80471-89190",
        "link": "tel:+91-8047189190"
    }
]
}

export const DefaultConfig = localConfig;